import { ButtonCollapsible } from '@bgea-js/design-library';
import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import MainContentJune2025 from "../../../../src/content/prayer-letter-june-2025/main-content-june-2025.md";
import LearnMoreJune2025 from "../../../../src/content/prayer-letter-june-2025/learn-more-details-june-2025.md";
import "../../../../src/content/prayer-letter-june-2025/prayer-letter-june-2025.scss";
import * as React from 'react';
export default {
  ButtonCollapsible,
  SingleDonationForm,
  MainContentJune2025,
  LearnMoreJune2025,
  React
};